export const EXCLUDED_ADDON_TYPES = ['mobile_replay', 'data_pipelines', 'data_warehouse_historical']
